@if (data(); as state) {
  <div class="card">
    <div class="card-body">
      @if (state.payouts; as payouts) {
        @if (payouts.length > 0) {
          <div class="overflow-x-auto" #container>
            <table class="table table-sm table-pin-rows table-pin-cols" #table>
              <thead>
                <tr>
                  <td>Payment Date</td>
                  <td>Type</td>
                  <td>Transaction Amount</td>
                  <td>Account</td>
                  <td>Wallet</td>
                  <td>Source</td>
                  <th>
                    <div class="flex items-center gap-2">
                      @if (showArrows()) {
                        <button
                          class="btn btn-sm btn-outline"
                          (click)="scrollRight()">
                          <fa-icon [icon]="faChevronRight"></fa-icon>
                        </button>
                      }
                      <span class="grow"> Actions </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (d of payouts; track d.id) {
                  <tr>
                    <td>
                      {{ d.paymentDate?.timestamp | date: 'short' }}
                    </td>
                    <td>
                      @if (isTopUpRefund(d)) {
                        <span
                          class="badge badge-outline h-auto rounded-box gap-2">
                          <fa-icon [icon]="faRotateLeft"></fa-icon>
                          Top-Up Refund
                        </span>
                      } @else if (
                        d.payoutType && d.payoutType !== PayoutType.PT_TRANSFER
                      ) {
                        @if (payoutTypeMap[d.payoutType]; as payoutType) {
                          <span
                            class="badge badge-outline h-auto rounded-box gap-2">
                            <fa-icon [icon]="payoutType.icon"></fa-icon>
                            {{ payoutType.title }}
                          </span>
                        }
                      } @else if (d.transaction && d.transaction.type) {
                        @if (
                          creditTransactionTypeMap[d.transaction.type];
                          as creditTransactionType
                        ) {
                          <span
                            class="badge badge-outline h-auto rounded-box gap-2">
                            <fa-icon
                              [icon]="creditTransactionType.icon"></fa-icon>
                            {{ creditTransactionType.title }}
                          </span>
                        }
                      }
                    </td>
                    <td
                      class="font-medium whitespace-nowrap"
                      [class]="directionClass(d)">
                      {{ d.transaction?.amount | currency }}
                    </td>
                    <td>
                      @if (d.transaction?.account?.id) {
                        <app-account-card
                          type="card"
                          [accountId]="d.transaction?.account?.id"
                          [owner]="
                            d.transaction?.account?.owner
                          "></app-account-card>
                      }
                    </td>
                    <td>
                      <div class="flex flex-col gap-1 items-start">
                        <app-wallet-kind-badge
                          [account]="d.transaction?.account"
                          [small]="true"></app-wallet-kind-badge>
                        @if (fundingSource(d); as funding) {
                          <span
                            class="text-xs text-base-content/70 whitespace-nowrap flex items-center gap-1">
                            <fa-icon [icon]="funding.icon"></fa-icon>
                            {{ funding.title }}
                            @if (walletKindTitle(funding.counterpart); as kind) {
                              &middot; {{ kind }} wallet
                            }
                          </span>
                        }
                      </div>
                    </td>
                    <td>
                      @if (
                        d.transaction?.type ===
                        CreditTransactionType.CTT_TRANSFER_IN
                      ) {
                        <div class="flex items-center gap-2">
                          <fa-icon [icon]="faArrowLeft"></fa-icon>
                          <app-account-card
                            type="card"
                            [accountId]="d.accountTransfer?.fromAccount?.id"
                            [owner]="
                              d.accountTransfer?.fromAccount?.owner
                            "></app-account-card>
                        </div>
                      } @else if (
                        d.transaction?.type ===
                        CreditTransactionType.CTT_TRANSFER_OUT
                      ) {
                        <div class="flex items-center gap-2">
                          <fa-icon [icon]="faArrowRight"></fa-icon>
                          <app-account-card
                            type="card"
                            [accountId]="d.accountTransfer?.toAccount?.id"
                            [owner]="
                              d.accountTransfer?.toAccount?.owner
                            "></app-account-card>
                        </div>
                      } @else if (
                        d.payoutType === PayoutType.PT_USAGE ||
                        d.transaction?.type === CreditTransactionType.CTT_REFUND
                      ) {
                        <div class="flex items-center gap-2">
                          @if (
                            d.transaction?.type ===
                              CreditTransactionType.CTT_REFUND && d.agent?.id
                          ) {
                            <app-user-card
                              type="text"
                              [userId]="d.agent?.id"></app-user-card>
                          }
                          @if (d.source && d.source.type) {
                            @if (typeMap[d.source.type]; as type) {
                              <span
                                class="badge badge-outline h-auto rounded-box gap-2">
                                @if (type.icon) {
                                  <fa-icon [icon]="type.icon"></fa-icon>
                                }
                                {{ type.title }}
                              </span>
                            }
                            @switch (d.source.type) {
                              @case (Type.T_DIALER_CALL) {
                                <button
                                  class="btn btn-sm btn-outline"
                                  (click)="openSource(d)">
                                  @if (d.source.lead?.phone) {
                                    {{ d.source.lead.phone }}
                                  } @else {
                                    {{ d.source.lead?.firstName }}
                                    {{ d.source.lead?.lastName }}
                                  }
                                </button>
                              }
                              @case (Type.T_APPOINTMENT) {
                                <button
                                  class="btn btn-sm btn-outline"
                                  (click)="openSource(d)">
                                  @if (
                                    d.source.lead?.firstName &&
                                    d.source.lead?.lastName
                                  ) {
                                    {{ d.source.lead?.firstName }}
                                    {{ d.source.lead?.lastName }}
                                  } @else {
                                    {{ d.source.lead?.phone }}
                                  }
                                </button>
                              }
                              @case (Type.T_LEAD_DATA_PURCHASE) {
                                <button
                                  class="btn btn-sm btn-outline"
                                  (click)="openSource(d)">
                                  @if (
                                    d.source.lead?.firstName &&
                                    d.source.lead?.lastName
                                  ) {
                                    {{ d.source.lead?.firstName }}
                                    {{ d.source.lead?.lastName }}
                                  } @else {
                                    {{ d.source.lead?.phone }}
                                  }
                                </button>
                              }
                              @case (Type.T_SIGNAL_360) {
                                @if (
                                  d.source.lead?.firstName ||
                                  d.source.lead?.lastName
                                ) {
                                  <span
                                    class="badge badge-outline h-auto rounded-box">
                                    {{ d.source.lead?.firstName }}
                                    {{ d.source.lead?.lastName }}
                                  </span>
                                }
                              }
                            }
                          }
                        </div>
                      }
                    </td>
                    <th>
                      <div class="flex justify-end">
                        <button
                          type="button"
                          class="btn btn-ghost"
                          (click)="showPayment(d)">
                          <fa-icon [icon]="faEye"></fa-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <h3 class="text-center">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon> No payouts found
          </h3>
        }
        @if (state.loading || !state.payouts) {
          <div class="skeleton h-16 w-full"></div>
        }
      }
    </div>
  </div>
} @else {
  <div class="skeleton h-16 w-full"></div>
}
